import React from 'react';
import { withRouter } from 'react-router';
import { Alert, Modal, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { PageStatus } from 'enums';
import { Show } from 'Layout';
import { SamplesAPI } from "../../API";
import { Confirmation } from "../../Shared/Confirmation";
import moment from "moment/moment";
import UsersSample from "./UsersSample";

type State = {
  data: any,
  status: string,
  error: string | null,
};


class Details extends React.Component<any, any> {
  // Hey! sonarqube, Please ignore this code
  // static defaultProps = {
  //   languageId: null,
  //   hideMenu: false,
  //   onUpdate: () => null,
  // };

  constructor(props) {
    super(props);
    this.state = {
      data: null,
      users: [],
      count: 0,
      status: PageStatus.None,
      error: null,
    };
  }

  componentDidMount() {
    if (this.props.id) {
      this.fetch();
    }
  }

  fetch() {
    Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Loading }))
      .then(() => {
        if (!this.props.id) {
          return Promise.reject(new Error('Invalid ID'));
        }
        return SamplesAPI.getOne(this.props.id);
      })
      .then((survey: any) => {
        if (survey) {
          let sampleFullData = survey.sample ? survey.sample : survey.samplemain;
          this.setState({ data: sampleFullData, users: survey.user, count: survey.totalCount, status: PageStatus.Loaded });
        }
      })
      .catch((error) => {
        this.setState({ status: PageStatus.Error, error: error.message });
      });
  }


  onDelete() {
    Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Loading }))
      .then(() => {
        if (!this.props.id) {
          return Promise.reject(new Error('Invalid ID'));
        }
        return SamplesAPI.deleteOne(this.props.id);
      })
      .then((country) => {
        this.setState({ status: PageStatus.Loaded });
        return this.props.onDelete()

      })
      .catch((error) => {
        this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  getPlatformString() {
    const data = this.state.data || {};
    const platforms = [];

    const buildPlatformString = (label, platformMap) => {
      const active = Object.entries(platformMap)
        .filter(([key, val]) => data[key] === "Y")
        .map(([_, name]) => name);
      return active.length ? `${label} (${active.join(", ")})` : null;
    };

    const desktop = buildPlatformString("Desktop", {
      desktopWindows: "Windows",
      desktopMac: "Mac"
    });

    const tablet = buildPlatformString("Tablet", {
      tabAndroid: "Android",
      tabIos: "iOS"
    });

    const mobile = buildPlatformString("Mobile", {
      mobileAndroid: "Android",
      mobileIos: "iOS"
    });

    [desktop, tablet, mobile].forEach(p => { if (p) platforms.push(p); });

    return platforms.join(", ");
  }



  render() {
    return (
      <Modal
        centered
        size="lg"
        backdrop="static"
        onHide={this.props.onClose}
        show
        style={{ zIndex: 1201 }}
      >
        <Modal.Header closeButton>
          <h5 className="mb-0 mt-1">Details</h5>
          <div
            className="d-flex justify-content-end w-100 mr-2"
          >
            <button
              type="button"
              onClick={() => this.props.onUpdate()}
              className="btn-sm btn-primary mr-2"
            >
              <FontAwesomeIcon
                icon={['fas', 'edit']}
                className="mr-2"
              />
              Update
            </button>
            <Confirmation onAction={() => this.onDelete()} body="Are you sure want to delete ?">
              <button
                type="button"
                title="End the call"
                className="btn call-end"
              >
                <FontAwesomeIcon
                  icon={['fas', 'trash']}
                  className="mr-2"
                />
              </button>
            </Confirmation>
          </div>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>

          <Show when={this.state.status === PageStatus.Loading}>
            <div className="d-flex justify-content-center w-100 p-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Show>

          <Show when={this.state.status === PageStatus.Loaded && !!this.state.data}>
            <div className="row mt-2">
              <div className="col">
                <strong>Name: </strong>
                {this.state.data?.name}
              </div>
              <div className="col">
                <strong>Profile Count: </strong>
                {this.state.data?.sampleType != "uniqueIdSample" ? this.state.data?.profileCount : this.state.count}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <strong>Registration Starts: </strong>
                {this.state.data?.fromRegistrationDate ? moment(this.state.data?.fromRegistrationDate ?? "").format("DD-MM-YYYY") : ""}
              </div>
              <div className="col">
                <strong>Registration Ends: </strong>
                {this.state.data?.toRegistrationDate ? moment(this.state.data?.toRegistrationDate ?? "").format("DD-MM-YYYY") : ""}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <strong>States: </strong>
                {this.state.data?.stateIds?.map(item => item.label).join(', ')}
              </div>
              <div className="col">
                <strong>Cities: </strong>
                {this.state.data?.cityIds?.map(item => item.label).join(', ')}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <strong>Regions: </strong>
                {this.state.data?.regions ? this.state.data?.regions.map(item => item.label).join(', ') : ''}
              </div>
              <div className="col">
                <strong>Segments: </strong>
                {this.state.data?.segments ? this.state.data?.segments.map(item => item.label).join(', ') : ''}
              </div>
            </div>

            <div className="row mt-2">
              <div className="col">
                <strong>Active: </strong>
                {this.state.data?.isActive === true ? 'Yes' : 'No'}
              </div>
              <div className="col">
                <strong>Device Targeted: </strong>
                {this.getPlatformString()}
              </div>
            </div>

            <div className="row mt-2">
              <div className="col">
                <strong>Description: </strong>
                {this.state.data?.description}
              </div>
            </div>

            {this.state.data?.genders?.map((item, index) => (
              <div key={"statedData" + index} className="row mt-2">
                <div className="col">
                  <strong>Gender: </strong>
                  {item?.gender?.length > 0 && item.gender.map((gender, idx) => (
                    <span key={"gender" + idx}>{gender?.label}{idx !== item.gender?.length - 1 ? ', ' : ''}</span>
                  ))}
                </div>
                <div className="col">
                  <strong>Min Age: </strong>
                  {item.fromAge}
                </div>
                <div className="col">
                  <strong>Max Age: </strong>
                  {item.toAge}
                </div>
              </div>
            ))}


            <div className="mt-5">
              <Show when={!this.state.count} >
                <div className="text-center">
                  No data
                </div>
              </Show>
              <Show when={!!this.state.count} >
                <UsersSample id={this.props.id} count={this.state.count} sample={this.state.data} />
              </Show>
            </div>

            <Alert
              variant="danger"
              show={this.state.status === PageStatus.Error}
            >
              {this.state.error}
            </Alert>
          </Show>
        </Modal.Body>
      </Modal>
    );
  }
}

const DetailsWithRouter = withRouter(Details);

export { DetailsWithRouter as Details };
